import { useCallback, useRef } from "react";
import { driver } from "driver.js";
import { setActiveDriver, clearActiveDriver } from "./driverRegistry";

export default function usePreloadTour() {
    const driverRef = useRef(null);

    const startTour = useCallback((_opts = {}) => {
        if (driverRef.current) {
            try { driverRef.current.destroy(); } catch (_) { /* noop */ }
        }

        const driverObj = driver({
            showProgress: true,
            animate: true,
            overlayColor: "rgba(0,0,0,0.55)",
            stagePadding: 8,
            stageRadius: 12,
            allowClose: false,
            steps: [
                {
                    element: "#tour-preload-heading",
                    popover: {
                        title: "Welcome to Datalyze!",
                        description: "This is where your analytics journey begins. Choose a data source to get started.",
                        side: "bottom",
                        align: "center",
                    },
                },
                {
                    element: '[data-tour-id="tour-preload-use-preloaded"]',
                    popover: {
                        title: "Preloaded Datasets",
                        description: "Click here to explore curated, real-world datasets organized by domain. This is the best way to start!",
                        side: "bottom",
                        align: "center",
                        showButtons: ["close"],
                    },
                },
            ],
        });

        driverRef.current = driverObj;
        setActiveDriver(driverObj);

        driverObj.onDestroyFinished = () => {
            clearActiveDriver();
        };
        driverObj.drive();
    }, []);

    return startTour;
}
